<template>
  <div>
    <!-- <div class="form-row mb-3" style="align-items: end"> -->
      <!-- <div class="col-sm-12"> -->
        <div v-if="this.active != 1" class="mb-2">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-if="this.active < 4"> <a href="" @click.prevent="previous">Back</a></el-breadcrumb-item>
            <el-breadcrumb-item>View</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 4"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>
    <el-form v-if="active === 1">
      <task-form-index @id="setId" :active="{ active }" :taskId="task_id"></task-form-index>
    </el-form>
    <el-form v-if="active === 2">
      <form-preview :back="previous" :id="id" :form_id="form_id" :form_revision_id="form_revision_id" :taskId="task_id" :active="{ active }"></form-preview>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "TaskForms",
  data() {
    return {
      active: 1,
      id: 0,
      invoice_id: 0,
      form_id: 0,
      form_revision_id: 0,
      task_id: this.$attrs['props'].id,
    };
  },
  methods: {
    setId(id,form_id,form_revision_id) {
      this.active = 2;
      this.id = id;
      this.form_id = form_id;
      this.form_revision_id = form_revision_id;
    },
    // invoiceid(id) {
    //   this.active = 3;
    //   this.invoice_id = id;
    // },
    previous() {
        // if (this.active-- < 4) this.active = this.active--;
        this.active = 1;
    },
  },
//   mounted() {
//     let id = ;
//     this.form_id = id
//     alert(this.form_id);
//   },
};
</script>
